function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// background click is just a convenience method, not an actual a11y issue

import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CardFlip, Select, SocketedButton } from '@deephaven/components';
import { vsGear } from '@deephaven/icons';
import { TableUtils } from '@deephaven/jsapi-utils';
import memoizee from 'memoizee';
import memoize from 'memoize-one';
import debounce from 'lodash.debounce';
import { nanoid } from 'nanoid';
import Log from '@deephaven/log';
import "./DropdownFilter.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var log = Log.module('DropdownFilter');
var UPDATE_DEBOUNCE = 150;
export class DropdownFilter extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "dropdownRef", void 0);
    _defineProperty(this, "getCompatibleColumns", memoize((source, columns) => source != null ? columns.filter(_ref => {
      var type = _ref.type;
      return type !== undefined && TableUtils.isCompatibleType(type, source.columnType);
    }) : []));
    _defineProperty(this, "getColumnOptions", memoize((columns, selectedColumn) => {
      var selectedIndex = -1;
      var options = [];
      options.push(/*#__PURE__*/_jsx("option", {
        value: "-1",
        children: "Select a column"
      }, "placeholder"));
      columns.forEach((columnItem, index) => {
        options.push(/*#__PURE__*/_jsx("option", {
          value: index,
          children: this.getItemLabel(columns, index)
        }, "".concat(columnItem.name, "/").concat(columnItem.type)));
        if (selectedColumn !== null && columnItem.name === selectedColumn.name && columnItem.type === selectedColumn.type) {
          selectedIndex = index;
        }
      });
      return [options, selectedIndex];
    }));
    _defineProperty(this, "getSelectedOptionIndex", memoize((values, value) => values.indexOf(value)));
    _defineProperty(this, "getValueOptions", memoize(values => [/*#__PURE__*/_jsx("option", {
      value: "-1",
      children: DropdownFilter.PLACEHOLDER
    }, "-1"), ...values.map((val, index) => /*#__PURE__*/_jsx("option", {
      value: index
      // eslint-disable-next-line react/no-array-index-key
      ,
      children: val !== null && val !== void 0 ? val : '(null)'
    }, "".concat(index, "/").concat(val)))]));
    _defineProperty(this, "getItemLabel", memoizee((columns, index) => {
      var _columns$index = columns[index],
        name = _columns$index.name,
        type = _columns$index.type;
      if (index > 0 && columns[index - 1].name === name || index < columns.length - 1 && columns[index + 1].name === name) {
        var shortType = type.substring(type.lastIndexOf('.') + 1);
        return "".concat(name, " (").concat(shortType, ")");
      }
      return name;
    }, {
      max: 1000
    }));
    _defineProperty(this, "sendUpdate", debounce(() => {
      var onChange = this.props.onChange;
      var _this$state = this.state,
        column = _this$state.column,
        value = _this$state.value,
        isValueShown = _this$state.isValueShown;
      onChange({
        column,
        isValueShown,
        value: value !== null && value !== void 0 ? value : undefined
      });
    }, UPDATE_DEBOUNCE));
    this.handleColumnChange = this.handleColumnChange.bind(this);
    this.handleSettingsCancel = this.handleSettingsCancel.bind(this);
    this.handleSettingsClick = this.handleSettingsClick.bind(this);
    this.handleSettingsSave = this.handleSettingsSave.bind(this);
    this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
    this.handleDropdownKeyPress = this.handleDropdownKeyPress.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.dropdownRef = /*#__PURE__*/React.createRef();
    var _column = props.column,
      _isValueShown = props.isValueShown,
      _value = props.value;
    this.state = {
      column: _column,
      id: nanoid(),
      selectedColumn: _column,
      disableCancel: !_isValueShown,
      isValueShown: _isValueShown,
      value: _value
    };
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$props = this.props,
      source = _this$props.source,
      values = _this$props.values,
      isLoaded = _this$props.isLoaded;
    var _this$state2 = this.state,
      column = _this$state2.column,
      value = _this$state2.value,
      isValueShown = _this$state2.isValueShown;
    if (isLoaded) {
      if (source !== prevProps.source) {
        this.sourceUpdated();
      }
      if (values !== prevProps.values && value !== '' && !values.includes(value)) {
        // Value list loaded, but doesn't contain the current value
        this.resetValue();
      }
      if (isValueShown !== prevState.isValueShown) {
        if (isValueShown) {
          this.focusInput();
        }
      }
      if (column !== prevState.column || value !== prevState.value || isValueShown !== prevState.isValueShown) {
        this.sendUpdate();
      }
    }
  }
  componentWillUnmount() {
    this.sendUpdate.flush();
  }
  handleColumnChange(eventTargetValue) {
    var value = eventTargetValue;
    log.debug2('handleColumnChange', value);
    if (value != null && parseInt(value, 10) < 0) {
      this.setState({
        selectedColumn: null
      });
      return;
    }
    var _this$props2 = this.props,
      allColumns = _this$props2.columns,
      source = _this$props2.source;
    var columns = this.getCompatibleColumns(source, allColumns);
    this.setState({
      selectedColumn: columns[parseInt(value, 10)]
    });
  }
  handleDropdownKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      log.debug2('handleDropdownKeyPress');
      this.sendUpdate();
      this.sendUpdate.flush();
    }
  }
  handleValueChange(eventTargetValue) {
    var valueIndex = eventTargetValue;
    var index = parseInt(valueIndex, 10);
    // Default empty string value for 'clear filter'
    var value = '';
    var values = this.props.values;
    if (index >= 0 && index < values.length) {
      value = values[index];
    } else {
      log.debug2('Selected default item');
    }
    log.debug2('handleValueChange', value);
    this.setState({
      value
    });
  }
  handleSettingsCancel() {
    this.setState(_ref2 => {
      var column = _ref2.column;
      return {
        selectedColumn: column,
        isValueShown: true
      };
    });
  }
  handleSettingsSave() {
    this.setState(_ref3 => {
      var column = _ref3.column,
        selectedColumn = _ref3.selectedColumn,
        value = _ref3.value;
      return {
        column: selectedColumn,
        // Reset value if column changed
        value: column === selectedColumn ? value : '',
        isValueShown: true,
        disableCancel: false
      };
    });
  }
  handleSettingsClick(event) {
    event.stopPropagation();
    this.showSettings();
  }
  handleBackgroundClick(event) {
    // allow clicking anywhere in the background to select and focus the input
    if (event.target !== this.dropdownRef.current) {
      this.focusInput();
    }
  }
  sourceUpdated() {
    this.setState({
      column: null,
      selectedColumn: null,
      isValueShown: false,
      disableCancel: true,
      value: ''
    });
  }
  showSettings() {
    var column = this.state.column;
    this.setState({
      selectedColumn: column,
      isValueShown: false
    });
  }
  focusInput() {
    var _this$dropdownRef$cur;
    (_this$dropdownRef$cur = this.dropdownRef.current) === null || _this$dropdownRef$cur === void 0 || _this$dropdownRef$cur.focus();
  }
  resetValue() {
    this.setState({
      value: ''
    });
  }

  // Called by the parent component via ref
  clearFilter() {
    this.resetValue();
  }

  // Called by the parent component via ref
  setFilterState(_ref4) {
    var name = _ref4.name,
      type = _ref4.type,
      value = _ref4.value,
      isValueShown = _ref4.isValueShown;
    var column = name != null && type != null ? {
      name,
      type
    } : null;
    this.setState(_ref5 => {
      var oldValue = _ref5.value,
        oldIsValueShown = _ref5.isValueShown;
      return {
        column,
        value: value !== null && value !== void 0 ? value : oldValue,
        isValueShown: isValueShown !== null && isValueShown !== void 0 ? isValueShown : oldIsValueShown
      };
    });
  }
  render() {
    var _source$columnName;
    var _this$props3 = this.props,
      allColumns = _this$props3.columns,
      disableLinking = _this$props3.disableLinking,
      isLinkerActive = _this$props3.isLinkerActive,
      isLoaded = _this$props3.isLoaded,
      source = _this$props3.source,
      onColumnSelected = _this$props3.onColumnSelected,
      onSourceMouseEnter = _this$props3.onSourceMouseEnter,
      onSourceMouseLeave = _this$props3.onSourceMouseLeave,
      values = _this$props3.values,
      settingsError = _this$props3.settingsError;
    var _this$state3 = this.state,
      column = _this$state3.column,
      disableCancel = _this$state3.disableCancel,
      id = _this$state3.id,
      isValueShown = _this$state3.isValueShown,
      selectedColumn = _this$state3.selectedColumn,
      value = _this$state3.value;
    var columnSelectionDisabled = source === null;
    var columns = this.getCompatibleColumns(source, allColumns);
    var isLinked = source != null;
    var sourceButtonLabel = (_source$columnName = source === null || source === void 0 ? void 0 : source.columnName) !== null && _source$columnName !== void 0 ? _source$columnName : DropdownFilter.SOURCE_BUTTON_PLACEHOLDER;
    var filterTitle = column != null ? "".concat(column.name, " Filter") : null;
    var _this$getColumnOption = this.getColumnOptions(columns, selectedColumn),
      _this$getColumnOption2 = _slicedToArray(_this$getColumnOption, 2),
      columnOptions = _this$getColumnOption2[0],
      selectedIndex = _this$getColumnOption2[1];
    var valueOptions = this.getValueOptions(values);
    var selectedOption = this.getSelectedOptionIndex(values, value);
    var disableSave = !isLinked || selectedColumn == null;
    var isFlipped = isValueShown && !isLinkerActive;
    var sourceColumnId = "source-column-btn-".concat(id);
    var filterColumnId = "filter-column-select-".concat(id);
    return /*#__PURE__*/_jsxs(CardFlip, {
      className: "dropdown-filter fill-parent-absolute",
      isFlipped: isFlipped,
      children: [/*#__PURE__*/_jsx("div", {
        className: "dropdown-filter-settings-card",
        children: /*#__PURE__*/_jsxs("div", {
          className: "dropdown-filter-card-content",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "dropdown-filter-settings-grid",
            children: [/*#__PURE__*/_jsx("label", {
              htmlFor: sourceColumnId,
              children: "Source Column"
            }), /*#__PURE__*/_jsx(SocketedButton, {
              id: sourceColumnId,
              isLinked: isLinked,
              onClick: onColumnSelected,
              onMouseEnter: onSourceMouseEnter,
              onMouseLeave: onSourceMouseLeave,
              className: DropdownFilter.SOURCE_BUTTON_CLASS_NAME,
              disabled: disableLinking,
              children: sourceButtonLabel
            }), /*#__PURE__*/_jsx("div", {
              className: "text-muted small",
              children: "Select a source column for the list by linking to a table."
            }), /*#__PURE__*/_jsx("label", {
              htmlFor: filterColumnId,
              children: "Filter Column"
            }), /*#__PURE__*/_jsx(Select, {
              id: filterColumnId,
              value: String(selectedIndex),
              className: "custom-select",
              onChange: this.handleColumnChange,
              disabled: columnSelectionDisabled,
              children: columnOptions
            }), /*#__PURE__*/_jsx("div", {
              className: "text-muted small",
              children: "Dropdown filter control will apply its filter to all columns matching this name in this dashboard."
            })]
          }), settingsError && /*#__PURE__*/_jsx("div", {
            className: "error-message text-center",
            children: settingsError
          }), isLinked && /*#__PURE__*/_jsxs("div", {
            className: "dropdown-filter-settings-buttons",
            children: [/*#__PURE__*/_jsx(Button, {
              kind: "secondary",
              type: "button",
              onClick: this.handleSettingsCancel,
              disabled: disableCancel || isValueShown || isLinkerActive,
              tooltip: isLinkerActive ? 'Cancel disabled while linker open' : undefined,
              children: "Cancel"
            }), /*#__PURE__*/_jsx(Button, {
              kind: "primary",
              type: "button",
              className: "ml-2",
              onClick: this.handleSettingsSave,
              disabled: disableSave || isValueShown || isLinkerActive,
              tooltip: isLinkerActive ? 'Save disabled while linker open' : undefined,
              children: "Save"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "dropdown-filter-value-card",
        onClick: this.handleBackgroundClick,
        "data-testid": "dropdown-filter-value-background",
        children: isLoaded && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "dropdown-filter-column",
            children: /*#__PURE__*/_jsx("div", {
              className: "dropdown-filter-column-title",
              children: filterTitle
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "dropdown-filter-card-content",
            children: [/*#__PURE__*/_jsx("div", {
              className: "dropdown-filter-value-input d-flex flex-column justify-content-center",
              children: /*#__PURE__*/_jsx(Select, {
                className: "custom-select",
                value: String(selectedOption),
                ref: this.dropdownRef,
                onChange: this.handleValueChange,
                onKeyDown: this.handleDropdownKeyPress,
                title: "Select Value",
                children: valueOptions
              })
            }), settingsError && /*#__PURE__*/_jsx("div", {
              className: "error-message mt-3 text-center",
              children: settingsError
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "dropdown-filter-menu",
            children: /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: "m-2 px-2",
              onClick: this.handleSettingsClick,
              icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: vsGear,
                transform: "grow-4"
              }),
              tooltip: "Dropdown Filter Settings"
            })
          })]
        })
      })]
    });
  }
}
_defineProperty(DropdownFilter, "defaultProps", {
  column: null,
  disableLinking: false,
  isLinkerActive: false,
  isLoaded: false,
  isValueShown: false,
  settingsError: null,
  source: null,
  value: '',
  values: [],
  onColumnSelected: () => undefined,
  onSourceMouseEnter: () => undefined,
  onSourceMouseLeave: () => undefined
});
_defineProperty(DropdownFilter, "PLACEHOLDER", 'Select a value...');
_defineProperty(DropdownFilter, "SOURCE_BUTTON_CLASS_NAME", 'btn-dropdown-filter-selector');
_defineProperty(DropdownFilter, "SOURCE_BUTTON_PLACEHOLDER", 'Select a column');
export default DropdownFilter;
//# sourceMappingURL=DropdownFilter.js.map